import request, { requestV2 } from "@/config/serve.js";

// 获取筛选选项
export function getFilterOptions(params) {
  return requestV2(
    "post",
    "/desktopUpdatePromotion/filterOptions",
    params,
    false
  );
}

// 获取列表数据
export function getList(params) {
  return requestV2("post", "/desktopUpdatePromotion/list", params, false);
}

// 新增
export function addRecord(params) {
  return requestV2("post", "/desktopUpdatePromotion/save", params, false);
}

// 编辑
export function editRecord(params) {
  return requestV2("post", "/desktopUpdatePromotion/update", params, false);
}

// 上线下线状态更新
export function updateStatus(params) {
  return requestV2(
    "post",
    "/desktopUpdatePromotion/updateStatus",
    params,
    false
  );
}
